export enum UserPaymentDetailsFormFields {
  // Pix
  PixKey = 'pix_key',

  // Upi
  ImpsAccountHolder = 'imps_account_holder',
  ImpsIfsc = 'imps_ifsc',

  // Bank Account
  BankAccountNumber = 'bank_account_number',
}
